// :cow: Cosmose CONFIDENTIAL :iso:
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChartDataSeriesPipe } from '@coa/app/shared/chart-data-series/pipes/chart-data-series/chart-data-series.pipe';
import { LabelValuePipe } from '@coa/app/shared/chart-data-series/pipes/label-value/label-value.pipe';
import { SpyLineChartDataSeriesPipe } from './pipes/spy-line-chart-data-series/spy-line-chart-data-series.pipe';
import { ChartDataMultiSeriesPipe } from '@coa/app/shared/chart-data-series/pipes/chart-data-series/chart-data-multi-series.pipe';
import { ChartSeriesPipe } from '@coa/app/shared/chart-data-series/pipes/chart-data-series/chart-series.pipe';


@NgModule({
  declarations: [
    ChartDataSeriesPipe,
    LabelValuePipe,
    SpyLineChartDataSeriesPipe,
    ChartDataMultiSeriesPipe,
    ChartSeriesPipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    ChartDataSeriesPipe,
    LabelValuePipe,
    SpyLineChartDataSeriesPipe,
    ChartDataMultiSeriesPipe,
    ChartSeriesPipe,
  ],
})
export class ChartDataSeriesModule {
}
